module.exports = __webpack_public_path__ + "media/img/down-icon-blue-20299df8b5aad06d3ae2943df72edb17.svg";